import { DyfFeatureGuideContentProps } from '../../../../../views/dyf-landing-view/hooks/use-dyf-feature-guide-content';
import { FeatureArticleCardBookmarkIcon } from '../bookmark-icon/feature-article-card-bookmark-icon';
import React, { useContext } from 'react';
import { BookmarkContext } from '../../../../../views/dyf-landing-view/context/dyf-bookmark-context';
import { UiFeature } from '../../../../../hooks/dyf/use-your-vehicle-features/vehicle-features.types';
import { useHistory } from 'react-router-dom';

export interface SingleFeatureArticleCardProps {
    item: UiFeature;
    titleHref: string;
    featureGuideContent: DyfFeatureGuideContentProps;
}

export const SingleFeatureArticleCard = (
    props: SingleFeatureArticleCardProps
) => {
    const { item, titleHref, featureGuideContent } = props;
    const { shouldShowBookmarkFeature } = useContext(BookmarkContext);
    const history = useHistory();

    const handleClick = (
        event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
    ) => {
        event.preventDefault();
        history.push(titleHref);
        window.location.reload();
    };

    return (
        <div
            className="article-card-content"
            data-testid="single-dyf-feature-article"
        >
            <div className="article-card-details">
                <div className="article-card-title">
                    <a type="tertiary" href={titleHref} onClick={handleClick}>
                        {item?.title}
                    </a>
                </div>
                <div className="article-card-description">
                    {item?.shortDescription}
                </div>
                {shouldShowBookmarkFeature && (
                    <FeatureArticleCardBookmarkIcon
                        item={props.item}
                        bookmarkAriaLabel={
                            featureGuideContent?.bookmarkAriaLabel
                        }
                    />
                )}
            </div>
        </div>
    );
};
